exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-38a2d608] table > tbody > tr > td {\n\tcursor: pointer;\n}\ninput[type='text'][data-v-38a2d608] {\n\twidth: 100%;\n\tpadding: 12px 20px;\n\tmargin: 4px 0;\n\tbox-sizing: border-box;\n\tborder: none;\n\t/*background-color: grey;\n\t\tcolor: white;*/\n}\n.clearfixx[data-v-38a2d608]::after {\n\tcontent: '';\n\tclear: both;\n\tdisplay: inline-block;\n}\n.b-table-sticky-header[data-v-38a2d608],\n.table-responsive[data-v-38a2d608],\n[class*='table-responsive-'][data-v-38a2d608] {\n\tmargin-bottom: 1rem;\n\toverflow-x: auto;\n}\n", ""]);

// exports
